import React, { Component } from 'react';
import ClickedOffManager from '../ui_core/ClickedOffManager';
import DistanceHelper from '../geometry/DistanceHelper';
import Urls from '../urls/Urls';
import './NearbySites.css';
export default class NearbySite{
	constructor({siteJson, thisSiteJson}){
		this._element = document.createElement('div');
		this._element.classList.add('nearby-site');
		this._imageWrapperElement = document.createElement('div');
		this._imageWrapperElement.classList.add('image-wrapper');
		this._imgElement = document.createElement('img');
		this._textElement = document.createElement('div');
		this._textElement.classList.add('text');
		this._distanceElement = document.createElement('div');
		this._distanceElement.classList.add('distance');
		this._element.appendChild(this._imageWrapperElement);
		this._imageWrapperElement.appendChild(this._imgElement);
		const configuration = siteJson.configuration;
		this._imgElement.src = Urls.getAssetsForSite(configuration.siteSlug)
			+'/'+siteJson.birdsEyeViews.getDefault().imageRelativePath;
		this._element.appendChild(this._textElement);
		this._textElement.innerHTML=configuration.siteName;
		this._distanceElement.innerHTML = '&nbsp;('+String(Math.round(DistanceHelper.calculateKmFromLatLng(siteJson.latLng, 
				thisSiteJson.latLng)))+'km)';
		this._textElement.appendChild(this._distanceElement);
	}
	get element(){
		return this._element;
	}
}
